import * as React from 'react';
import { Row, FluidContainer } from 'common--design-library';
import classnames from 'classnames';

export interface ITableProps {
    header?: React.ReactNode | React.ReactNode[];
    footer?: React.ReactNode | React.ReactNode[];
    children?: React.ReactNode | React.ReactNode[];
    className?: string;
    strapped?: boolean;
    roleForTest?: string;
}

export const TablePanel: React.FC<ITableProps> = (props: ITableProps) => {
    return (
        <FluidContainer className={classnames('table-panel', props.className, { strapped: props.strapped })} data-test-role={props.roleForTest}>
            {props.header && <Row className="table-panel-header">{props.header}</Row>}
            {props.children && props.children}
            {props.footer && <Row className="table-panel-footer">{props.footer}</Row>}
        </FluidContainer>
    );
};
